module.exports = __webpack_public_path__ + "img/文档.64e8d9ec.svg";